"use strict";

angular.module("internal.exams").controller("InternalExamSessionDocument", [
    "$scope",
    "$stateParams",
    "$state",
    "EXSessions",
    "Documents",
    "DocumentTypes",
    "FileTypes",
    "EXCandidates",
    function ($scope, $stateParams, $state, EXSessions, Documents, DocumentTypes, FileTypes, EXCandidates) {

        $scope.examSessionID = $stateParams.examSessionID;
        $scope.documentID = $stateParams.documentID;
        $scope.candidateID = $stateParams.candidateID;
        $scope.loading = true;

        if ($stateParams.documentID != null) {
            Documents.getByID($stateParams.documentID).then(function (document) {
                $scope.document = document;
                $scope.document.candidateID = $scope.candidateID;
                $scope.loading = false;
            })
        } else {
            $scope.document = { candidateID: $scope.candidateID };
            FileTypes.getByEnterprise().then(function (data) {
                if (data != null && data.length > 0) {
                    $scope.extensions = data.toString();
                } else {
                    $scope.extensions = '*';
                }
                $scope.loading = false;
            });
        }

        DocumentTypes.get().then(function (types) {
            $scope.types = types;
        })

        EXCandidates.getCandidateBySession($scope.examSessionID).then(function (candidates) {
            $scope.candidates = candidates.records;

            $scope.candidates.forEach(function (candidate) {
                candidate.name = candidate.candidateUserDisplayName;
                candidate.id = candidate.candidateUserId;
            })
        })

        EXSessions.getsessionsummary($stateParams.examSessionID).then(function (sessionSummary) {
            $scope.sessionSummary = sessionSummary;
        });

        $scope.save = function () {
            $scope.saving = true;
            if ($scope.documentID == null) {
                Documents.upload($scope.document, $scope.examSessionID).then(function (document) {
                    if (document != null) {
                        $state.go('internal.exams.session.documents', { examSessionID: $scope.examSessionID });
                    }
                    else {
                        alert("Upload failed. File is too large");
                    }
                    $scope.saving = false;
                });
            }
            else {
                Documents.save($scope.document, true, $scope.documentID).then(function (document) {
                    $state.go('internal.exams.session.documents', { examSessionID: $scope.examSessionID });
                    $scope.saving = false;
                });
            }
        }

        $scope.delete = function () {
            $scope.deleting = true;
            Documents.delete($scope.documentID).then(function () {
                $scope.deleting = false;
                $state.go('internal.exams.session.documents', { examSessionID: $scope.examSessionID });
            });
        }



    }
]);
